import { styled } from '@mui/material/styles';
import Divider from '@mui/material/Divider';

export const CustomDivider = styled(Divider)({
	'& .MuiDivider-wrapper': {
		padding: '0',
	},
});
